import { render, staticRenderFns } from "./OnsiteSearchGroup.vue?vue&type=template&id=4c0b5a14&"
import script from "./OnsiteSearchGroup.vue?vue&type=script&lang=ts&"
export * from "./OnsiteSearchGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports